export default __webpack_public_path__ + "static/media/grid_new.8c12ed4e.png";